import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EcapGql } from '@ecap3/app-platform-graphql';
import {
    GqlQueryBuilderService,
    ShellDomainProvider,
    SqlQueryBuilderService,
    StorageDataService,
    UserInfoService,
    UtilityService
} from '@ecap3/core';
import { TranslateService } from '@ngx-translate/core';
import {
    CalendarEvent,
    CalendarEventAction
} from 'angular-calendar';
import * as dayjs from 'dayjs';
import { map as _map, unionBy } from 'lodash';
import * as moment from 'moment';
import {
    BehaviorSubject,
    Observable,
    Subject,
    combineLatest,
    forkJoin,
    of
} from 'rxjs';
import { catchError, debounceTime, map, switchMap, take, tap } from 'rxjs/operators';
import {
    CalendarEventModel,
    IAppPlatformCalendar,
    PlatfromCalendarService
} from 'src/app/business/app-platform-calendar';
import { Entity } from 'src/app/business/app-projects-wishlist/models/GQLGenericResponse';
import { IProductStanding } from 'src/app/business/app-projects-wishlist/models/IProductStanding';
import { DELTA_CONFIG, ScheduleStatus } from 'src/app/delta-config/constant/delta-config.constant';
import { SCHEDULE_EVENT_FILTER_KEY } from '../../business/app-schedule/constants/schedule-event.constant';
import { DeltaBusinessService } from '../../shared/services/delta-business.service';
import { OfflineNotificationService } from '../../shared/services/offline-notification.service';
import { Announcement } from '../interfaces/Announcement.interface';
import { DressCode } from '../interfaces/DressCode.interface';
import { Person } from '../models/ecap.model';
import { DeltaGqlService } from './delta-gql.service';
import { SnackbarService } from './snackbar.service';

const colors: any = {
    requested: {
        primary: '#bc31ea',
        secondary: '#ffffff'
    },
    booked: {
        primary: '#00a760',
        secondary: '#00a760'
    },
    accepted: {
        primary: '#00a760',
        secondary: 'transparent'
    },
    reserved: {
        primary: '#ffa700',
        secondary: '#ffa7001A'
    },
    rejected: {
        primary: '#ff0c3e',
        secondary: '#ff0c3e1A'
    },
    leave: {
        primary: '#ff0c3e',
        secondary: '#ff0c3e'
    },
    pending: {
        primary: '#ffa700',
        secondary: '#ffffff'
    },
    project: {
        primary: '#1F8EFA',
        secondary: ''
    }
};

@Injectable({
    providedIn: 'root'
})
export class ScheduleCalendarService implements IAppPlatformCalendar {
    loggedInEmployeeId;
    loggedInUserPersonId;
    loggedInEmployeeItemId;
    loggedInUserInfo;
    isAdmin;
    currentEmployeeId;
    employeeScheduleChangeFromModalEvent = new Subject();
    calendarEventsLoading: Subject<boolean> = new Subject();
    deleteResponse = new Subject();
    currentUser = new BehaviorSubject<any>('');
    dateRange = new BehaviorSubject(null);
    calendarView = new BehaviorSubject(null);
    isBottomSheetClosed = new BehaviorSubject(false);
    deltaEmployeeLeaveSchedules = [];

    timeRange;

    actions: CalendarEventAction[] = [
        {
            label: '<i class="fa fa-fw fa-pencil"></i>',
            a11yLabel: 'Edit',
            onClick: ({ event }: { event: CalendarEvent }): void => {
                this.handleEvent('Edited', event);
            }
        },
        {
            label: '<i class="fa fa-fw fa-times"></i>',
            a11yLabel: 'Delete',
            onClick: ({ event }: { event: CalendarEvent }): void => {
                this.handleEvent('Deleted', event);
            }
        }
    ];
    calendarEvents: CalendarEvent[];
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    personId: string;
    employeeId: string;

    constructor(
        private http: HttpClient,
        private GQL: EcapGql,
        private route: ActivatedRoute,
        private userInfoService: UserInfoService,
        private platformCalendarService: PlatfromCalendarService,
        private deltaBusinessService: DeltaBusinessService,
        private deltaGqlService: DeltaGqlService,
        private snackbarService: SnackbarService,
        private storageService: StorageDataService,
        private sqlQueryBuilderService: SqlQueryBuilderService,
        private offlineNotificationService: OfflineNotificationService,
        private utilityService: UtilityService,
        private readonly translateService: TranslateService,
        private gqlQueryBuilderService: GqlQueryBuilderService
    ) {
        this.getPersonInfo();
    }

    async getPersonInfo() {
        await this.userInfoService
            .getLoggedInPersonInfo()
            .pipe(take(1))
            .subscribe({
                next: (person: Person) => {
                    console.log('Person', person);
                    this.personId = person.ItemId;

                    this.deltaBusinessService
                        .queryEntityData(
                            'DeltaEmployee',
                            ['ItemId'],
                            `PersonId: '${this.personId}'`
                        )
                        .subscribe({
                            next: (resp) => {
                                console.log(resp);
                                this.employeeId =
                                    resp &&
                                    resp.Data &&
                                    resp.Data[0] &&
                                    resp.Data[0].ItemId;
                            }
                        });
                }
            });
    }

    handleEvent(action: string, event: CalendarEvent): void {
        console.log(event);
    }

    getCurrentEmployeeId(route) {
        console.log(this.employeeId);
        console.log(this.personId);

        return this.employeeId;
    }

    removeCanceldProjects(projects) {
        const employeeId = this.getCurrentEmployeeId(this.route);
        const formatedProjects = [];
        projects.forEach((project) => {
            const index = project.Assignees.findIndex(
                (assignee) =>
                    assignee.Employee.EmployeeId === employeeId &&
                    assignee.Status !== 'cancel'
            );
            if (index !== -1) {
                formatedProjects.push(project);
            }
        });
        return formatedProjects;
    }

    isWeekExistsBetweenTwoMonths(viewDate) {
        const startDate = moment(viewDate).startOf('isoWeek');
        const endDate = moment(viewDate).endOf('isoWeek');
        if (startDate.month() !== endDate.month()) {
            return true;
        } else {
            return false;
        }
    }

    getDateRange(viewDate, view) {
        let dateRange = {
            start: null,
            end: null
        };
        let startDate;
        let endDate;

        if (view === 'month' || view === 'week') {
            startDate = moment(viewDate).startOf('month');
            endDate = moment(viewDate).endOf('month');
        }

        if (view === 'week' && this.isWeekExistsBetweenTwoMonths(viewDate)) {
            const weekStartDate = moment(viewDate).startOf('isoWeek');
            const weekEndDate = moment(viewDate).endOf('isoWeek');

            startDate = moment(weekStartDate).startOf('month');
            endDate = moment(weekEndDate).endOf('month');
        }

        console.log(viewDate); 
        if (view === 'schedule') {
            startDate = dayjs(viewDate).set('hour', 0).set('minute', 0).set('second', 0);
            endDate = dayjs(viewDate).add(2,'month').set('hour', 23).set('minute', 59).set('second', 59);
        }

        if (!startDate || !endDate) return dateRange;

        dateRange = {
            start: startDate.toISOString(),
            end: endDate.toISOString()
        };
        console.log(dateRange);
        return dateRange;
    }

    checkIsAdmin() {
        this.isAdmin = false;
        const subject = new Subject();
        this.userInfoService.currentUser.pipe(take(1)).subscribe({
            next: (res: any) => {
                if (res.Roles) {
                    for (const role of res.Roles) {
                        if (
                            role === 'admin' ||
                            role === 'hr_member'
                        ) {
                            this.isAdmin = true;
                            break;
                        }
                    }
                    subject.next(this.isAdmin);
                }
            }
        });
        return subject.asObservable();
    }
    getCalendarEvents(
        viewDate?,
        daysOfMonthInCalendarBody?,
        personInfo?,
        view?,
    ): Observable<CalendarEventModel[]> {
        this.checkIsAdmin();
        this.timeRange = this.getDateRange(viewDate, view);
        const personId = personInfo.ItemId;
        this.calendarEventsLoading.next(true);

        return this._fetchAndConvertEvents(personId, this.timeRange).pipe(
            tap(() => this.calendarEventsLoading.next(false))
        );
    }
    fetchFilteredData(personId: string): Observable<CalendarEventModel[]> {
        return combineLatest([this.dateRange, this.calendarView])
            .pipe(
                take(1),
                switchMap(([date, calendarView]) => {
                    const dateRange = this.getDateRange(date, calendarView);
                    this.calendarEventsLoading.next(true);

                    return this._fetchAndConvertEvents(personId, dateRange).pipe(
                        tap(() => this.calendarEventsLoading.next(false))
                    );
                })
            );
    }
    updateEvent(event) {
        this.platformCalendarService.OnEventUpdate(event);
    }
    getCalendarEventsOnLangChange(
        calendarEvents?
    ): Observable<CalendarEventModel[]> {
        const retranslated = (calendarEvents || []).map((event) => {
            const leaveType = event?.emebeddedInfo?.LeaveType;
            if (leaveType) {
                const beKey = this.getLeaveTypeForBE(leaveType);
                const key = beKey === 'day_off' ? beKey : beKey.toUpperCase();
                return { ...event, title: this.translateService.instant(key) };
            }
            return event;
        });
        return of(retranslated);
    }
    checkIsSameDay(d1, d2) {
        d1 = new Date(d1);
        d2 = new Date(d2);
        return (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate() &&
            !(
                d1.getHours() === 0 &&
                d1.getMinutes() === 0 &&
                d2.getHours() === 23 &&
                d2.getMinutes() === 59
            )
        );
    }
    getFormatedProjectData(assigneeData) {
        const formatedProject = { ...assigneeData };
        formatedProject.forWhom = 'project';
        formatedProject.status = assigneeData.AssignmentStatus;
        formatedProject.assigneeId = assigneeData.AssigneeId;
        formatedProject.Title = formatedProject.ScheduleTitle
            ? formatedProject.ScheduleTitle
            : formatedProject.EmployeeUnavailabilityTitle
            ? formatedProject.EmployeeUnavailabilityTitle
            : "I can't work on";

        return formatedProject;
    }
    getProjectEvent(assigneeData) {
        const formatedProject = this.getFormatedProjectData(assigneeData);

        let eventColor = colors.project;

        const status = assigneeData.AssignmentStatus;

        if (status === 'booked') {
            eventColor = colors.booked;
        } else if (status === 'accepted') {
            eventColor = colors.accepted;
        } else if (status === 'invited') {
            eventColor = colors.requested;
        } else if (status === 'reserved') {
            eventColor = colors.reserved;
        } else if (status === 'rejected') {
            eventColor = colors.rejected;
        }

        const schedule = {
            start: new Date(assigneeData.StartDateTime),
            end: new Date(assigneeData.EndDateTime),
            color: eventColor,
            title: formatedProject.Title,
            actions: null,
            emebeddedInfo: formatedProject,
            
            allDay: false
        };
        return schedule;
    }
    getEmployeeEvent(employeeSchedule) {
        employeeSchedule = this.getFormatedEmployeeSchedule(employeeSchedule);
        const title = employeeSchedule.ScheduleTitle
            ? employeeSchedule.ScheduleTitle
            : "I can't work on";
        employeeSchedule.Title = employeeSchedule.ScheduleTitle
            ? employeeSchedule.ScheduleTitle
            : employeeSchedule.EmployeeUnavailabilityTitle
            ? employeeSchedule.EmployeeUnavailabilityTitle
            : "I can't work on";
        employeeSchedule.Note = employeeSchedule.Note
            ? employeeSchedule.Note
            : employeeSchedule.ProjectNote
            ? employeeSchedule.ProjectNote
            : employeeSchedule.EmployeeUnavailabilityNote;
        const isAllDay = this.checkIsSameDay(
            employeeSchedule.StartDateTime,
            employeeSchedule.EndDateTime
        );

        const eventColor = employeeSchedule.ActionStatus === 'pending'
            ? { primary: '#ff0c3e', secondary: '#ffffff' } // Red frame, white background
            : colors.leave; // All other leave statuses are Red

        const schedule = {
            start: new Date(employeeSchedule.StartDateTime),
            end: new Date(employeeSchedule.EndDateTime),
            color: eventColor,
            title: title,
            actions: this.getActions(employeeSchedule),
            emebeddedInfo: employeeSchedule,
            allDay: !isAllDay
        };
        return schedule;
    }
    getBlockdayEvent(event) {
        const schedule = {
            start: new Date(
                dayjs(event.UtcBlockedDate)
                    .set('hour', 0)
                    .set('minute', 0)
                    .set('second', 0)
                    .format()
            ),
            end: new Date(
                dayjs(event.UtcBlockedDate)
                    .set('hour', 23)
                    .set('minute', 59)
                    .set('second', 59)
                    .format()
            ),
            title: event.Title,
            actions: [],
            emebeddedInfo: {...event, ScheduleType: ScheduleStatus.LEAVE},
            allDay: true,
            color: colors.leave
        };
        return schedule;
    }
  
    getHolidayEvent(event){
        return this.createHolidayEvent(event.UtcBlockedDate, event.Title, event);
    }

    createHolidayEvent(date: any, title: string, eventDetails: any) {
        const schedule = {
            start: new Date(dayjs(date).set('hour', 0).set('minute', 0).set('second', 0).format()),
            end: new Date(dayjs(date).set('hour', 23).set('minute', 59).set('second', 59).format()),
            title: title,
            actions: [],
            emebeddedInfo: {...eventDetails, ScheduleType: ScheduleStatus.LEAVE},
            allDay: true,
            color: colors.leave
        };
        return schedule;
    }

    convertDataToEvent(employeeScheduleData): CalendarEventModel[] {
        const events: CalendarEventModel[] = [];
        employeeScheduleData.forEach((employeeSchedule) => {
            if (employeeSchedule.LeaveType) {
                employeeSchedule.LeaveType = this.getLeaveTypeForFE(
                    employeeSchedule.LeaveType
                );
            }
            if (employeeSchedule.ScheduleType === 'leave') {
                const schedule = this.getEmployeeEvent(employeeSchedule);
                events.push(schedule);
            } else if (employeeSchedule.ScheduleType === 'work') {
                const schedule = this.getProjectEvent(employeeSchedule);
                events.push(schedule);
            } else if (employeeSchedule.Title === 'Block Days') {
                const schedule = this.getBlockdayEvent(employeeSchedule);
                events.push(schedule);
            } else if (employeeSchedule.Description === 'holiday') {
                const schedule = this.getHolidayEvent(employeeSchedule);
                events.push(schedule);
            }
        });
        return events;
    }

    getDNAHolidayData(filters: string) {
		return this.deltaGqlService.getEntityData(
				DELTA_CONFIG.Entity.HolidayInformation,
				DELTA_CONFIG.AllFieldsOfEntity.HolidayInformation,
				filters,
			)
			.pipe(
				take(1),
				map((response: any) => {
					if (response?.Data) {
						return response.Data.map(item => ({
						  ...item,
                          Description: 'holiday',
						  UtcBlockedDate: new Date(this.adJustTimeZoneWithDates(item.HolidayDate))
						}));
					}
					return [];
				}),
				catchError((err) => of([]))
			);
	}

    adJustTimeZoneWithDates(specifiedDate: Date): string {
		const timezoneOffset = new Date().getTimezoneOffset();
		const minuteValue = new Date(specifiedDate).getMinutes() + timezoneOffset;
		const date = new Date(specifiedDate).setMinutes(minuteValue);
		return new Date(date).toISOString();
	}

    private getDeltaEmployeeCanton(personId: string): Observable<string | null> {
        return this.deltaBusinessService.queryEntityData(
            DELTA_CONFIG.Entity.DeltaEmployee,
            ['Canton'],
            `PersonId: '${personId}'`
        ).pipe(
            take(1),
            map((resp: any) => resp?.Data?.[0]?.Canton || null),
            catchError(() => of(null))
        );
    }

    private filterHolidaysByEmployeeCanton(holidays: any[], employeeCanton: string | null): any[] {
        if (!employeeCanton) {
            return holidays;
        }
        return holidays.filter(holiday => {
            const cantons: string[] = holiday.Cantons || [];
            if (cantons.length === 0) {
                return false;
            }
            return cantons.includes(employeeCanton);
        });
    }

    getFormatedEmployeeSchedule(employeeSchedule) {
        employeeSchedule.forWhom = employeeSchedule.ScheduleType;
        employeeSchedule.status =
            employeeSchedule.ScheduleType === 'leave'
                ? employeeSchedule.LeaveType
                : 'scheduled';
        employeeSchedule.StartDateTime = new Date(new Date(employeeSchedule.StartDateTime_ZoneSpecific).getTime() - Math.abs(new Date(employeeSchedule.StartDateTime_ZoneSpecific).getTimezoneOffset()) * 60000).toISOString();
        employeeSchedule.EndDateTime = new Date(new Date(employeeSchedule.EndDateTime_ZoneSpecific).getTime() - Math.abs(new Date(employeeSchedule.EndDateTime_ZoneSpecific).getTimezoneOffset()) * 60000).toISOString();

        return employeeSchedule;
    }

    getActions(schedule) {
        return [];
    }

    checkIsUnavialabilityEditable(schedule) {
        if (schedule.ScheduleType && schedule.ScheduleType === 'scheduled') {
            if (schedule.IsSystemGenerated && !this.isAdmin) {
                return false;
            } else if (schedule.IsSystemGenerated && this.isAdmin) {
                return true;
            } else if (!schedule.IsSystemGenerated) {
                return true;
            }
        }
    }

    getProjectsBetweenDateRangeFilter(employeeId, dateRange) {
        const eventStartWithinRangefilterWithoutISO =
            `'Assignees': {$elemMatch: {'DateRange.StartDateTime': {$gte: '${dateRange.start}', ` +
            `$lte: '${dateRange.end}'}, 'Employee.EmployeeId' : '${employeeId}', 'Status' : {$ne: 'cancel'} }}`;
        const eventEndWithinRangefilterWithoutISO =
            `'Assignees': {$elemMatch: {'DateRange.EndDateTime': {$gte: '${dateRange.start}', ` +
            `$lte: '${dateRange.end}'}, 'Employee.EmployeeId' : '${employeeId}', 'Status' : {$ne: 'cancel'} }}`;
        const eventStartEndNotWithinRangeFilterWithoutISO =
            `'Assignees': {$elemMatch: {'DateRange.StartDateTime': {$lt: '${dateRange.start}'}, ` +
            `'DateRange.EndDateTime': {$gt: '${dateRange.end}'}, 'Employee.EmployeeId' : '${employeeId}', 'Status' : {$ne: 'cancel'} }}`;
        const withoutIsofilter = `$or: [{${eventStartWithinRangefilterWithoutISO}},{${eventEndWithinRangefilterWithoutISO}},{${eventStartEndNotWithinRangeFilterWithoutISO}}]`;

        const eventStartWithinRangefilter =
            `'Assignees': {$elemMatch: {'DateRange.StartDateTime': {$gte: ISODate('${dateRange.start}'), ` +
            `$lte: ISODate('${dateRange.end}')}, 'Employee.EmployeeId' : '${employeeId}', 'Status' : {$ne: 'cancel'} }}`;
        const eventEndWithinRangefilter =
            `'Assignees': {$elemMatch: {'DateRange.EndDateTime': {$gte: ISODate('${dateRange.start}'), ` +
            `$lte: ISODate('${dateRange.end}')}, 'Employee.EmployeeId' : '${employeeId}', 'Status' : {$ne: 'cancel'} }}`;
        const eventStartEndNotWithinRangeFilter =
            `'Assignees': {$elemMatch: {'DateRange.StartDateTime': {$lt: ISODate('${dateRange.start}')}, ` +
            `'DateRange.EndDateTime': {$gt: ISODate('${dateRange.end}')}, 'Employee.EmployeeId' : '${employeeId}', 'Status' : {$ne: 'cancel'} }}`;

        const withIsofilter = `$or: [{${eventStartWithinRangefilter}},{${eventEndWithinRangefilter}},{${eventStartEndNotWithinRangeFilter}}]`;

        const filter = `$or: [{${withoutIsofilter}}, {${withIsofilter}}]`;
        return filter;
    }

    uploadDocument(
        selectedFiles,
        tag: string,
        connectionObj?: any,
        accessModifier?: any
    ) {
        const resultAggregate = [];
        const aggreagetPayload = [];

        const presignedUrl = ShellDomainProvider['api'].BusinessService + 'DeltaService/Storage/GetPreSignedUrlForUploadByRolePriority';
        const files: any[] = Array.from(selectedFiles);

        const psuCalls$ = files.map(file => {
            const psu = this.storageService.generatePSU(this.utilityService.getNewGuid(), file.name, null, [tag], accessModifier);
            return this.http.post(presignedUrl, psu, { headers: this.header, withCredentials: true, observe: 'response' });
        });

        return forkJoin(psuCalls$).pipe(
            switchMap((responses: any[]) => {
                for (const r of responses) {
                    const parsed = r.body;
                    if (ShellDomainProvider['api'].IsStaging) parsed.UploadUrl = parsed.UploadUrl.replace('http:', 'https:');
                    resultAggregate.push(parsed);
                }
                const uploadCalls$ = resultAggregate.map((item, key) =>
                    this.storageService.uploadPresignedFile(item.UploadUrl, files[key])
                );
                return forkJoin(uploadCalls$);
            }),
            map(() => ({
                resultAggregate,
                FileIds: resultAggregate.length > 0 ? _map(resultAggregate, 'FileId') : [],
                fileUploaded: resultAggregate.length > 0
            }))
        );
    }

    getEmployeeFilter(personId, dateRange, isEmployeeSchedule = false) {
        const leaveStartWithinRangefilter = `StartDateTime: {$gte: ISODate('${dateRange.start}'), $lte: ISODate('${dateRange.end}')}`;
        const leaveEndWithinRangefilter = `EndDateTime: {$gte: ISODate('${dateRange.start}'), $lte: ISODate('${dateRange.end}')}`;
        const leaveStartEndNotWithinRangeFilter = `StartDateTime: {$lt: ISODate('${dateRange.start}')}, EndDateTime: {$gt: ISODate('${dateRange.end}')}`;
        let filter = `$and: [ `;
        filter += `{ $or: [{${leaveStartWithinRangefilter}},{${leaveEndWithinRangefilter}},{${leaveStartEndNotWithinRangeFilter}}] }`;
        
        let filterKeys = JSON.parse(localStorage.getItem(SCHEDULE_EVENT_FILTER_KEY)) || ['invited', 'booked', 'reserved', 'accepted'];
        filterKeys = filterKeys.filter(key => key !== 'all');
        const nonRejectedKeys = filterKeys.filter(key => key !== 'rejected');

        if(isEmployeeSchedule){
            filter += `]`;

            filterKeys = nonRejectedKeys.filter(key => key === "booked");
            
            filter += `AssignmentStatus: {$in:[${filterKeys.map((key) : string => `'${key}'`).join(',')}]}`;
            filter += ', IsVisibleInEmployee: true';
        } else {
            filterKeys = nonRejectedKeys.filter(key => key !== "booked");
            const statusList = filterKeys.map((key) => `'${key}'`).join(','); 
            const nowIso = new Date().toISOString();
            console.log(nowIso);
            
            const assignmentStatusFilter = `ScheduleType: 'work', AssignmentStatus: { $in: [${statusList}] }, $or: [ { AssignmentType: { $ne: 'Wishlist' } }, { AssignmentType: 'Wishlist', AssignmentStatus: { $ne: 'rejected' }, WishlistDeadline: { $gte: ISODate('${nowIso}') } } ]`;
            const leaveStatusKeys = filterKeys.includes('accepted') && !filterKeys.includes('partial')
                ? [...filterKeys, 'partial']
                : filterKeys;
            const scheduleTypeFilter = `ScheduleType: 'leave', EmployeeActionStatus: {$in:[${leaveStatusKeys
                .map(
                    (key): string => `'${key === "invited" ? "pending" : key}'`
                )
                .join(',')}]}`;

            filter += `, { $or: [{${assignmentStatusFilter}},{${scheduleTypeFilter}}] } ]`;
        }

        filter += `, PersonId : '${personId}', IsMarkedToDelete : false`;

        return filter;
    }

    getScheduleEvents(personId, timeRange2?) {
        if (timeRange2) {
            this.timeRange = timeRange2;
        }
        const employeeBookedScheduleFilter = this.getEmployeeFilter(personId, this.timeRange, true);
        const employeeOtherScheduleFilter = this.getEmployeeFilter(personId, this.timeRange);

        const start = dayjs(this.timeRange.start).utc().startOf('day').toISOString();
        const end = dayjs(this.timeRange.end).utc().endOf('day').toISOString();
        const holidayFilter = `HolidayDate:{$gte:ISODate('${start}'),$lt:ISODate('${end}')}`;

        return combineLatest([
            this.getEmployeeBookedSchedules(employeeBookedScheduleFilter),
            this.getEmployeeOtherSchedules(employeeOtherScheduleFilter),
            this.getDNAHolidayData(holidayFilter),
            this.getDeltaEmployeeCanton(personId)
        ])
            .pipe(
                take(1),
                debounceTime(800),
                map((res: any) => {
                    const [bookedSchedules, otherSchedules, holidays, employeeCanton] = res;
                    const filteredHolidays = this.filterHolidaysByEmployeeCanton(holidays, employeeCanton);
                    const activeOtherSchedules = this._excludeExpiredAcceptedOpenPositions(otherSchedules);
                    const reservedOverAcceptedSchedules = this._keepReservedOverAccepted(activeOtherSchedules);
                    const filteredOtherSchedules = this._excludeAcceptedOpenPositionDuplicates(bookedSchedules, reservedOverAcceptedSchedules);
                    const translatedOtherSchedules = this._translateScheduleEvents(filteredOtherSchedules);
                    return bookedSchedules.concat(translatedOtherSchedules, filteredHolidays);
                })
            );
    }

    getEmployeeBookedSchedules(scheduleFilter) {
        return this.deltaGqlService.queryAllData(
            DELTA_CONFIG.Entity.ScheduleEvent,
            DELTA_CONFIG.SpecificFields.ScheduleEvent,
            scheduleFilter
        )
            .pipe(take(1), map((resp: any) => resp?.Data));
    }

    getEmployeeOtherSchedules(scheduleFilter){
        return this.deltaGqlService.queryAllData(
            DELTA_CONFIG.Entity.ScheduleEvent,
            DELTA_CONFIG.SpecificFields.ScheduleEvent,
            scheduleFilter
        )
            .pipe(take(1), map((resp: any) => resp?.Data));
    }

    getDeltaEmployeeLeaveSchedules(leaveIds){
        return new Promise((resolve, reject) => {
            const filter = `_id: {$in: [${leaveIds.map(id => `'${id}'`)}]}`;
            this.deltaGqlService.queryAllData(
                DELTA_CONFIG.Entity.DeltaEmployeeLeaveSchedule,
                DELTA_CONFIG.AllFieldsOfEntity.DeltaEmployeeLeaveSchedule,
                filter
            )
                .pipe(take(1), map((resp: any) => resp?.Data))
                .subscribe({
                    next: (res: any) => {
                        this.deltaEmployeeLeaveSchedules = res;
                        resolve(true);
                    }
                })
        });
    }
    
    async compressLeaveSchedule(data: any[]) {
        const returnData: any[] = [];
        returnData.push(
            ...data.filter(
                (leave) =>
                    !(
                        leave.DeltaEmployeeLeaveId &&
                        leave.DeltaEmployeeLeaveId.length > 0
                    )
            )
        );
        let leaveIds = data
            .filter(
                (leave) =>
                    leave.DeltaEmployeeLeaveId &&
                    leave.DeltaEmployeeLeaveId.length > 0
            )
            .map((item) => item.DeltaEmployeeLeaveId);
        leaveIds = unionBy(leaveIds);

        await this.getDeltaEmployeeLeaveSchedules(leaveIds);

        for (const leaveId of leaveIds) {
            let tempData: any[] = data.filter(
                (item) => item.DeltaEmployeeLeaveId === leaveId
            );
            tempData = tempData.sort(
                (a, b) =>
                    new Date(a.StartDateTime).getTime() -
                    new Date(b.StartDateTime).getTime()
            );
            const schedule = this.deltaEmployeeLeaveSchedules.find(schedule => schedule.ItemId === leaveId);
            if (schedule) {
                tempData[0].StartDateTime = schedule.StartDateTime;
                tempData[0].EndDateTime = schedule.EndDateTime;
                returnData.push(tempData[0]);
            }
        }
        return returnData;
    }

    getEmployeeUnavailabilities() {
        const subject = new Subject();
        const employeeId = this.getCurrentEmployeeId(this.route);
        this.getEntityData(
            DELTA_CONFIG.Entity.DeltaEmployee,
            DELTA_CONFIG.SpecificFields.DeltaEmployee,
            `_id : '${employeeId}'`
        )
            .pipe(take(1))
            .subscribe({
                next: (response) => {
                    this.loggedInEmployeeItemId =
                        response.data.DeltaEmployees.Data[0].ItemId;
                    let sessions =
                        response &&
                        response.data &&
                        response.data.DeltaEmployees &&
                        response.data.DeltaEmployees.Data &&
                        response.data.DeltaEmployees.Data[0] &&
                        response.data.DeltaEmployees.Data[0].Unavailabilities;
                    if (!sessions) {
                        sessions = [];
                    }
                    subject.next(sessions);
                }
            });
        return subject.asObservable();
    }

    deleteUnavailability(currentSchedule) {
        const subject = new Subject();
        this.deleteEntityData(
            DELTA_CONFIG.Entity.DeltaEmployeeSchedule,
            currentSchedule.EmployeeUnavailabilityId
        )
            .pipe(take(1))
            .subscribe({
                next: (res) => {
                    if (
                        res.data &&
                        res.data.DeltaEmployeeSchedule &&
                        res.data.DeltaEmployeeSchedule.Success
                    ) {
                        subject.next(true);
                        this.snackbarService.success();
                    } else {
                        subject.next(false);
                        this.snackbarService.error();
                    }
                },
                error: (err) => {
                    this.snackbarService.error();
                }
            });
        return subject.asObservable();
    }

    getEmployeeData() {
        const subject = new Subject();
        this.userInfoService.currentUser.pipe(take(1)).subscribe({
            next: (res) => {
                this.getEmployeeUnavailabilities()
                    .pipe(take(1))
                    .subscribe({
                        next: (resp: any) => {
                            const scheduleData =
                                resp.data.DeltaEmployees.Data[0].EmployeeSchedules;
                            this.loggedInEmployeeId =
                                resp.data.DeltaEmployees.Data[0].ItemId;
                            subject.next(scheduleData);
                        }
                    });
            }
        });
        return subject.asObservable();
    }

    updateSchedule(scheduleData) {
        return this.GQL.mutate({
            mutation: this.gqlQueryBuilderService.prepareUpdateModel(
                DELTA_CONFIG.Entity.DeltaEmployee,
                scheduleData,
                this.loggedInEmployeeId
            )
        }).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((e) => of({ Data: [], TotalCount: 0 }))
        );
    }

    setSchedule(data) {
        const subject = new Subject();
        this.userInfoService.currentUser.pipe(take(1)).subscribe({
            next: (res) => {
                const updatedData = {
                    Unavailabilities: data,
                    Tags: ['DeltaEmployee']
                };
                this.updateEntityData(
                    DELTA_CONFIG.Entity.DeltaEmployee,
                    updatedData,
                    this.loggedInEmployeeItemId
                )
                    .pipe(take(1))
                    .subscribe({
                        next: (resp) => {
                            subject.next(resp.data.DeltaEmployee);
                        }
                    });
            }
        });
        return subject.asObservable();
    }

    changeAssigneeStatus(payload) {
        const subject = new Subject();
        this.deltaBusinessService
            .changeAssigneeStatus(payload)
            .pipe(take(1))
            .subscribe({
                next: (resp: any) => {
                    subject.next(resp);
                },
                error: (err) => {
                    console.log(err);
                }
            });
        return subject.asObservable();
    }

    acceptInvitation(statusData) {
        const subject = new Subject();
        const entityName = DELTA_CONFIG.Entity.DeltaProject;
        const updatedvalue = {
            Assignees: statusData.Assignees,
            Tags: ['DeltaProject']
        };
        const entityId = statusData.ItemId;
        this.updateEntityData(entityName, updatedvalue, entityId)
            .pipe(take(1))
            .subscribe({
                next: (res) => {
                    subject.next(res.data.DeltaProject);
                }
            });
        return subject.asObservable();
    }

    getEntityData(
        entityName,
        propertyNames,
        filter,
        orderBy?,
        pageNumber?,
        pageSize?
    ) {
        return this.GQL.watchQuery<any>({
            query: this.gqlQueryBuilderService.prepareQuery(
                entityName,
                propertyNames,
                filter,
                orderBy ? orderBy : 'CreateDate: -1',
                pageNumber ? pageNumber : 0,
                pageSize ? pageSize : 100
            )
        }).valueChanges.pipe(
            map((res: any) => {
                return res;
            }),
            catchError((e) => of(e))
        );
    }

    updateEntityData(entityName, updatedvalue, entityId) {
        return this.GQL.mutate({
            mutation: this.gqlQueryBuilderService.prepareUpdateModel(
                entityName,
                updatedvalue,
                entityId
            )
        }).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((e) => of({ e }))
        );
    }

    deleteEntityData(entityName, entityId) {
        return this.GQL.mutate({
            mutation: this.gqlQueryBuilderService.prepareDeleteModel(
                entityName,
                entityId
            )
        }).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((e) => of({ e }))
        );
    }

    setEntityData(entityName, value) {
        return this.GQL.mutate({
            mutation: this.gqlQueryBuilderService.prepareInsertModel(
                entityName,
                value
            )
        }).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((e) => of({ e }))
        );
    }

    getProjectsAndEmployeeData(projectIds, employeeId) {
        const filter = `'_id': { '$in': ['${projectIds.join("','")}']}`;
        const deltaProjectConfig = {
            entityName: DELTA_CONFIG.Entity.DeltaProject,
            fields: DELTA_CONFIG.AllFieldsOfEntity.DeltaProject,
            filters: filter,
            Sort: 'CreateDate: -1'
        };

        const deltaEmployeeConfig = {
            entityName: DELTA_CONFIG.Entity.DeltaEmployee,
            fields: DELTA_CONFIG.SpecificFields.DeltaEmployee,
            filters: `_id : '${employeeId}'`,
            Sort: 'CreateDate: -1'
        };
        const query = [];
        query.push(
            'DeltaProject:' +
                this.gqlQueryBuilderService.buildQueryBasic(deltaProjectConfig)
        );
        query.push(
            'DeltaEmployee:' +
                this.gqlQueryBuilderService.buildQueryBasic(deltaEmployeeConfig)
        );

        return this.GQL.watchQuery<any>({
            query: this.gqlQueryBuilderService.aggregateMultipleQuery(query)
        }).valueChanges;
    }
    getProjectsData(projectIds) {
        const filter = `'_id': { '$in': ['${projectIds.join("','")}']},IsVisibleInEmployee: true`;
        const deltaProjectConfig = {
            entityName: DELTA_CONFIG.Entity.DailyProjectInformation,
            fields: DELTA_CONFIG.AllFieldsOfEntity.DailyProjectInformation,
            filters: filter,
            Sort: 'CreateDate: -1'
        };
        const query = [];
        query.push(
            'DeltaProject:' +
                this.gqlQueryBuilderService.buildQueryBasic(deltaProjectConfig)
        );
        return this.GQL.watchQuery<any>({
            query: this.gqlQueryBuilderService.aggregateMultipleQuery(query)
        }).valueChanges;
    }

    getAssignedProjectIds(projects) {
        const projectIds = [];

        projects.forEach((project) => {
            if (project.Status === 'booked' || project.Status === 'reserved') {
                projectIds.push(project.ProjectId);
            }
        });

        return projectIds;
    }

    restrictSchedule(payload) {
        const subject = new Subject();

        setTimeout(() => {
            this.deltaBusinessService
                .restrictEmployeeSchedule(payload)
                .pipe(take(1))
                .subscribe({
                    next: (resp: any) => {
                        if (resp && resp.body && resp.body.ResponseData) {
                            const projectIds = this.getAssignedProjectIds(
                                resp.body.ResponseData
                            );
                            subject.next(projectIds);
                        } else {
                            subject.next(null);
                        }
                    },
                    error: (err) => {
                        this.snackbarService.error(
                            'Error in Finding Part Time employee'
                        );
                    }
                });
        }, 0);

        return subject.asObservable();
    }

    sendMail(mailPayload) {
        return this.http.post(
            `${ShellDomainProvider['api'].EmailService}/MailCommand/SendEmail`,
            mailPayload,
            { headers: this.header, withCredentials: true, observe: 'response' }
        );
    }

    getUserIdsByAggregate(personIds) {
        const validIds = personIds.filter(id => !!id);
        if (!validIds.length) return of({ FailedCallIndex: -1, AggregateCallCompleted: true });
        const connectionsUrl = ShellDomainProvider['api'].DataCore + 'DataManipulationQuery/GetConnections';
        const calls$ = validIds.map(personId => {
            const connectQuery = this.sqlQueryBuilderService.prepareGetConnectionQuery('User', '', 'Person', personId, true, ['Person-For-User']);
            connectQuery['PageNumber'] = 0;
            connectQuery['PageLimit'] = 100;
            connectQuery['ExpandParent'] = false;
            connectQuery['ExpandChild'] = false;
            return this.http.post(connectionsUrl, connectQuery, { headers: this.header, withCredentials: true, observe: 'response' })
                .pipe(catchError(() => of({ body: null })));
        });
        return forkJoin(calls$).pipe(map((responses: any[]) => {
            const result: any = { FailedCallIndex: -1, AggregateCallCompleted: true };
            validIds.forEach((id, i) => { result[id] = responses[i].body; });
            return result;
        }));
    }

    sendNotificationToPlanners(personids: string[], employee) {
        this.getUserIdsByAggregate(personids).subscribe({
            next: (resp) => {
                console.log(resp);
                const userIds: string[] = [];
                for (const pId of personids) {
                    userIds.push(resp[`${pId}`].Results[0].ParentEntityID);
                }
                const payloads = [];
                userIds.forEach((uId) => {
                    const payload =
                        this.offlineNotificationService.getNotificationPayloadModel(
                            `LeaveRequest#${this.translateService.instant(employee.Salutation)} ${employee.DisplayName}#'${employee.ItemId}'`,
                            uId,
                            `leave-request/list-view`,
                            '',
                            null,
                            { TaskTitle: '', TaskCreator: '', DetailRoute: '' }
                        );
                    payloads.push(payload);
                });
                this.offlineNotificationService
                    .saveTaskAsNotificationWithAggregate(payloads)
                    .subscribe({
                        next: (res) => {
                            console.log(res);
                        }
                    });
            }
        });
    }

    sendMailsToPlanners(planners) {
        if (!planners.length) return of(true);
        const mailUrl = ShellDomainProvider['api'].EmailService + '/MailCommand/SendEmail';
        const calls$ = planners.map(planner => {
            const payload = this.getPlannerMailConfiguration(planner);
            return this.http.post(mailUrl, payload, { headers: this.header, withCredentials: true, observe: 'response' })
                .pipe(catchError(() => of({ body: null })));
        });
        return forkJoin(calls$).pipe(
            map(() => true),
            catchError(() => of(false))
        );
    }

    getPlannerMailConfiguration(planner) {
        const mailPayload: any = {
            Purpose: 'schedule_restrict',
            Language: 'en-US',
            Bcc: [],
            Cc: [],
            Subject: {
                additionalProp1: 'Schedule Restrict',
                additionalProp2: 'string 2',
                additionalProp3: 'string 3'
            },
            DataContext: {
                Name: planner.Name,
                Project: planner.ProjectName,
                AssignedEmployee: planner.AssignedEmployeeName
            },
            To: [planner.PersonId]
        };
        return mailPayload;
    }

    getFile(fileId) {
        return this.storageService.getFileInfo(fileId).pipe(
            map((response: any) => {
                if (response && response.body) {
                    return response.body;
                }
            })
        );
    }
    getLeaveTypeForBE(type: string) {
        return type.replace('-', '_').toLowerCase();
    }
    getLeaveTypeForFE(type: string) {
        return type
            .split('_')
            .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
            .join('-');
    }

    getDressTitle(dressCode): Observable<DressCode["Title"]> {
        return this.deltaGqlService
            .getEntityData(
                DELTA_CONFIG.Entity.DressCode,
                ['Title','Description'],
                `TenueCode: '${dressCode}'`
            )
            .pipe(
                take(1),
                map((res: Entity<DressCode["Title"]>)=>{
                    if(res.Success){
                        return res.Data[0] ; 
                    }
                    throw new Error(res.ErrorMessage);
                }),
            )
    }

    setAnnouncementFilters(dailyProjectId: string): string {
        let filters = `'Roles': {$size:0},`;
        filters += `'Projects': { $elemMatch: { DailyProjectId: '${dailyProjectId}' } },`;
        const updateDate = new Date();
        updateDate.setHours(0, 0, 0, 0);
        filters += `StartDate: {$lte: ISODate('${updateDate.toISOString()}')},`;
        filters += `EndDate: {$gte: ISODate('${updateDate.toISOString()}')}`;
        return filters;
    }

    getAnnoucement(dailyProjectId): Observable<Partial<Announcement>> {
        return this.deltaGqlService
            .getEntityData(
                DELTA_CONFIG.Entity.Announcement,
                DELTA_CONFIG.AllFieldsOfEntity.Announcement,
                this.setAnnouncementFilters(dailyProjectId),
                0,
                1,
                "'Priority': 1, 'StartDate': 1"
            )
            .pipe(
                take(1),
                map((res: Entity<Partial<Announcement>>)=>{ 
                    if(res.Success){
                        return res.Data; 
                    }
                    throw new Error(res.ErrorMessage);
                }),
                catchError((err)=>{
                    console.error(`[ScheduleCalendarService] Error: `, err);
                    return err;
                })
            )
    }
    getSurchargeInfos(productStandingId): Observable<IProductStanding["SurchargeInfos"]> {
        return this.deltaGqlService
            .getEntityData(
                DELTA_CONFIG.Entity.ProductStanding,
                [{ SurchargeInfos: ['ArticleId', 'ArticleDescription', 'SurchargeType'] }, 'StartDateTime', 'ControlInMinute'],
                `_id:  '${productStandingId}'`
            )
            .pipe(
                take(1),
                map((res: Entity<IProductStanding["SurchargeInfos"]>)=> {
                    if(res.Success){
                        return res.Data[0]
                    }
                    throw new Error(res.ErrorMessage);
                }),
            )
    }
    getWorkDescriptionFromStanding(productStandingId): Observable<IProductStanding> {
        return this.deltaGqlService
            .getEntityData(
                DELTA_CONFIG.Entity.ProductStanding,
                ['WorkDescription'],
                `_id:  '${productStandingId}'`
            )
            .pipe(
                take(1),
                map((res: Entity<IProductStanding>)=> {
                    if(res.Success){
                        return res.Data[0]
                    }
                    throw new Error(res.ErrorMessage);
                }),
            )
    }

    getWorkDescriptionFromAssignment(assigneeId): Observable<IProductStanding> {
        return this.deltaGqlService
            .getEntityData(
                DELTA_CONFIG.Entity.ProductAssignment,
                ['Remark'],
                `_id:  '${assigneeId}'`
            )
            .pipe(
                take(1),
                map((res: Entity<IProductStanding>)=> {
                    if(res.Success){
                        return res.Data[0]
                    }
                    throw new Error(res.ErrorMessage);
                }),
            )
    }

    getEventDetailBottomSheetData(dressCode: string, dailyProjetId: string, productStandingId: string, assigneeId: string, status: string = null): Observable<any> {
        const dressCode$ = this.getDressTitle(dressCode);
        const annoucement$ = this.getAnnoucement(dailyProjetId);
        const SurchargeInfos$ = this.getSurchargeInfos(productStandingId); 
        const WorkDescriptionFromStanding$ = this.getWorkDescriptionFromStanding(productStandingId);
        const WorkDescriptionFromProduct$ = this.getWorkDescriptionFromAssignment(assigneeId);
        const outputObsArray: Observable<any>[] = [dressCode$];
        if(status === 'booked'){
            outputObsArray.push(annoucement$);
            outputObsArray.push(SurchargeInfos$);
            outputObsArray.push(WorkDescriptionFromStanding$);
        } else if(assigneeId){
            outputObsArray.push(WorkDescriptionFromProduct$);
        }
        return forkJoin(outputObsArray).pipe(take(1));
    }

    private _fetchAndConvertEvents(personId: string, dateRange: any): Observable<CalendarEventModel[]> {
        const scheduleEvents$ = this.getScheduleEvents(personId, dateRange);
        const leaveBlocks$ = this._getLeaveBlocks(personId, dateRange);
        return combineLatest([scheduleEvents$, leaveBlocks$]).pipe(
            map(([scheduleEvents, leaveBlocks]) => {
                return this.convertDataToEvent(scheduleEvents.concat(leaveBlocks));
            })
        );
    }

    private _getLeaveBlocks(personId: string, dateRange: any): Observable<any[]> {
        return this.getEntityData(
            DELTA_CONFIG.Entity.DeltaEmployee,
            ["ItemId", "Category", "DisplayName"],
            `PersonId: '${personId}'`
        ).pipe(
            switchMap((deltaEmployeeResp: any) => this._fetchLeaveBlocksForEmployee(deltaEmployeeResp, dateRange))
        );
    }

    private _fetchLeaveBlocksForEmployee(deltaEmployeeResp: any, dateRange: any): Observable<any[]> {
        const deltaEmployeeData = deltaEmployeeResp.data.DeltaEmployees.Data || [];
        const deltaEmployee = deltaEmployeeData.length ? deltaEmployeeData[0] : null;
        const isCategoryC = deltaEmployee && deltaEmployee.Category === 'C';
        const descriptionFilter = isCategoryC ? `, Description: 'holiday'` : ``;
        const filter = `UtcBlockedDate:{$gte:ISODate('${dateRange.start}'),$lt:ISODate('${dateRange.end}')}, IsMarkedToDelete: false${descriptionFilter}`;

        return this.getEntityData(
            "DeltaLeaveBlockDaySchedule",
            ["ItemId", "UtcBlockedDate", "Title", "Note", "Description"],
            filter
        ).pipe(
            map(leaveBlockResp => leaveBlockResp?.data?.DeltaLeaveBlockDaySchedules?.Data || [])
        );
    }

    private _excludeExpiredAcceptedOpenPositions(otherSchedules: any[]): any[] {
        const now = Date.now();

        return (otherSchedules || []).filter((event) => {
            const isAcceptedOpenPosition = event.AssignmentStatus === 'accepted' && event.AssignmentType === 'OpenPosition';
            if (!isAcceptedOpenPosition || !event.StartDateTime) {
                return true;
            }
            return new Date(event.StartDateTime).getTime() >= now;
        });
    }

    private _keepReservedOverAccepted(otherSchedules: any[]): any[] {
        const reservedProductIds = new Set(
            (otherSchedules || [])
                .filter((event) => event.AssignmentStatus === 'reserved' && !!event.ProductId)
                .map((event) => event.ProductId)
        );

        return (otherSchedules || []).filter((event) => {
            const isDuplicateAccepted = event.AssignmentStatus === 'accepted' && reservedProductIds.has(event.ProductId);
            return !isDuplicateAccepted;
        });
    }

    private _excludeAcceptedOpenPositionDuplicates(bookedSchedules: any[], otherSchedules: any[]): any[] {
        const bookedProductIds = new Set(
            (bookedSchedules || [])
                .map((event) => event.ProductId)
                .filter((productId) => !!productId)
        );

        return (otherSchedules || []).filter((event) => {
            const isAcceptedOpenPosition = event.AssignmentStatus === 'accepted' && event.AssignmentType === 'OpenPosition';
            return !(isAcceptedOpenPosition && bookedProductIds.has(event.ProductId));
        });
    }

    private _translateScheduleEvents(events: any[]): any[] {
        return events.map((event) => {
            if (event.LeaveType) {
                const key = event.LeaveType === 'day_off' ? event.LeaveType : event.LeaveType.toUpperCase();
                const translation = this.translateService.instant(key);
                return {
                    ...event,
                    ScheduleTitle: translation
                };
            }
            return event;
        });
    }
}
